<script lang="ts"></script>

<img
  class="illustration"
  src="/assets/images/mini-tests/reflexe-cyber/illustration-reflexe-cyber-animee.svg"
  width="486"
  height="368"
  alt="Illustration animée d'une cyberattaque bloquant progressivement les applications d'une organisation"
/>

<style lang="scss">
  .illustration {
    display: block;
    margin: 0 auto;
    width: 100%;
  }
</style>
